/* helper.ts */

/* Ionic */
import { ban, warning } from "ionicons/icons";

/* Constants */
import { GlobalMessageType } from "src/shared/constants/common/GlobalMessage";

/* Interfaces */
import {
  ToastContentProps,
  ToastMessageProps,
} from "src/shared/interfaces/common/ToastMessage";

export const createToastMessage = (
  toast: ToastMessageProps
): ToastContentProps | undefined => {
  switch (toast.type) {
    case GlobalMessageType.SUCCESS:
      return {
        type: GlobalMessageType.SUCCESS,
        show: toast.show,
        message: toast.message,
        icon: undefined,
        color: "var(--ion-color-success)",
      };
    case GlobalMessageType.WARNING:
      return {
        type: GlobalMessageType.WARNING,
        show: toast.show,
        message: toast.message,
        icon: warning,
        color: "var(--ion-color-warning)",
      };
    case GlobalMessageType.ERROR:
      return {
        type: GlobalMessageType.ERROR,
        show: toast.show,
        message: toast.message,
        icon: ban,
        color: "var(--ion-color-error)",
      };
    default:
      return undefined;
  }
};
